import { useState, type ReactNode } from 'react'

import Button from '@components/atoms/Button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@components/atoms/DropdownMenu'

export type DotsMenuProps = {
  ariaLabel: string
  children: ReactNode
}

export function DotsMenu({ ariaLabel, children }: DotsMenuProps) {
  const [open, setOpen] = useState(false)

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          rank="secondary"
          size="sm"
          ariaLabel={ariaLabel}
          leadingIcon="dots-horizontal"
          className="tw:[&>svg]:rotate-90"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={() => setOpen(false)}>
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
